import { MdSearch } from "react-icons/md";

export function SearchBar({ value, onChange, placeholder }) {
   return (
      <div className="relative">
         <MdSearch
            size={16}
            className="absolute left-2.5 top-1/2 -translate-y-1/2 text-(--textColor) pointer-events-none"
         />
         <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder || "Search…"}
            className="w-full pl-8! pr-3! py-1.5! text-sm bg-(--inputBackgroundColor) border! border-(--borderColor)! rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent! transition"
         />
      </div>
   );
}
